import { createAction, props } from '@ngrx/store';

export const loadBetaFeatures = createAction(
  '[Beta Features] Load Beta Features'
);

export const enableBetaFeatures = createAction(
  '[Beta Features] Enable Beta Features'
);

export const disableBetaFeatures = createAction(
  '[Beta Features] Disable Beta Features'
);

export const setBetaFeatures = createAction(
  '[Beta Features] Set Beta Features',
  props<{ enabled: boolean }>()
);
